import { useTranslation } from 'react-i18next';
import type { StaticSharedField } from './types';
import type { quantityDropdownValue } from '/business/shared/components/pages/question/types';
import {
  ERR_TYPE_NUM_LARGE,
  ERR_TYPE_NUM_SMALL,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_NUMBER,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useMakeQuantity({
  quantityDropdownValues,
  label,
  subLabel,
  minLimit,
  maxLimit,
  errMsg,
  hasAsterisk,
}: {
  quantityDropdownValues?: quantityDropdownValue[];
  label?: React.ReactNode | string;
  subLabel?: string;
  minLimit?: number;
  maxLimit?: number;
  errMsg?: string;
  hasAsterisk?: boolean;
}): StaticSharedField {
  const { t } = useTranslation();
  const shouldIncludeDropdown = quantityDropdownValues !== undefined;
  const displaySelectFlag = !quantityDropdownValues || quantityDropdownValues.length === 0;
  return {
    type: FIELD_TYPE_NUMBER,
    propName: 'quantity',
    element: 'quantity',
    placeholderI18nKey: ' ',
    label: label || <>Quantity:</>,
    subLabel: subLabel ? <span>{subLabel}</span> : null,
    titleHasAsterisk: hasAsterisk ?? true,
    validation: [
      ...(hasAsterisk
        ? [
            {
              rule: ERR_TYPE_REQUIRED,
              errCode: 'ERRNOQUANTITY',
              errStr: errMsg || t('business:Errors.supplierForm.quantity'),
            },
          ]
        : []),
      {
        rule: ERR_TYPE_NUM_SMALL,
        errCode: 'ERRQUANTITYTOOLOW',
        errStr: errMsg || t('business:Errors.supplierForm.quantity'),
        value: minLimit ?? 0,
      },
      {
        rule: ERR_TYPE_NUM_LARGE,
        errCode: 'ERRQUANTITYTOOHIGH',
        errStr: errMsg || t('business:Errors.supplierForm.quantity'),
        value: maxLimit ?? 999999999,
      },
    ],
    ...(shouldIncludeDropdown
      ? {
          dropdown: {
            defaultValue: displaySelectFlag ? 'select' : quantityDropdownValues[0].name,
            propName: 'quantity_unit',
            values: displaySelectFlag
              ? [
                  {
                    name: 'select',
                    displayName: 'Unit',
                  },
                ]
              : quantityDropdownValues.map((value) => ({
                  name: value.name,
                  displayName: value.displayName,
                })),
          },
        }
      : {}),
  };
}
